import { Button } from '@mui/material';
import React from 'react';

const getOfferText = (product) =>
  `${product.offers.length} ${product.offers.length === 1 ? 'offer' : 'offers'} from ${
    product.salePrice
  }`;

export default function MobileOfferButton({ product, onOpenProductDrawer }) {
  return (
    <Button
      onClick={onOpenProductDrawer(product.id)}
      aria-label={`See details for ${product.name}`}
      sx={{
        width: '100%',
        borderRadius: 0,
        backgroundColor: 'orange.500',
        mt: 3,
        py: 2,
        color: 'common.black',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        '&:hover, &:focus': {
          backgroundColor: 'orange.700',
        },
      }}
    >
      {getOfferText(product)}
    </Button>
  );
}
